import { DOCUMENT } from '@angular/common';
import {
	Component,
	EventEmitter,
	Inject,
	Input,
	OnInit,
	Output
} from '@angular/core';
import { DeviceService } from 'app/core/services/device.service';
import { IAuthNewUserData } from 'app/interface/auth.new.interface';

@Component({
	selector: 'app-toolbar',
	templateUrl: './toolbar.component.html',
	styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {
	@Output() toggleSidebar = new EventEmitter<void>();
	@Input() isSidebarOpen: boolean = false;
	@Input() user: IAuthNewUserData | null = null;
	showLogo: boolean = false;
	elem: any;
	isFullscreen: boolean = false;
	isMobile: boolean;
	isIphone: boolean; //Fullscreen API not supported on iphones

	constructor(_device: DeviceService, @Inject(DOCUMENT) _document: Document) {
		this.elem = _document.documentElement;
		this.isMobile = _device.isMobile();
		this.isIphone = _device.isIphone();
	}

	setShowLogo(isOpen: boolean = null) {
		this.showLogo = this.isMobile || (isOpen ?? !this.isSidebarOpen);
	}

	ngOnInit(): void {
		this.setShowLogo();
	}

	enableFullscreen() {
		this.elem.requestFullscreen();
		this.isFullscreen = true;
	}
	exitFullscreen() {
		document.exitFullscreen();
		this.isFullscreen = false;
	}

	onToggleSidebar(): void {
		this.setShowLogo(!this.showLogo);
		this.toggleSidebar.emit();
	}
}
